/**
 * 시설물 관련 상수 정의
 */

import { FacilityType, IFacilityTypeInfo } from '../@types/facility.types';

/** 시설물 유형 목록 */
export const FACILITY_TYPES: IFacilityTypeInfo[] = [
    { code: 'bridge', label: '교량, 육교', description: '교량 및 육교 시설물', icon: 'fa-solid fa-bridge' },
    { code: 'tunnel', label: '터널, 지하차도', description: '터널 및 지하차도 시설물', icon: 'fa-solid fa-road-barrier' },
    { code: 'retaining_wall', label: '옹벽', description: '옹벽 시설물', icon: 'fa-solid fa-wall-brick' },
    { code: 'cut_slope', label: '절토사면', description: '절토사면 시설물', icon: 'fa-solid fa-mountain' },
    { code: 'building', label: '건축물, 지하도상가', description: '건축물 및 지하도상가', icon: 'fa-solid fa-building' },
];

/** 시설물 유형 코드 → 라벨 매핑 */
export const FACILITY_TYPE_LABELS: Record<string, string> = Object.fromEntries(
    FACILITY_TYPES.map(t => [t.code, t.label])
);

/** 시설물 유형별 스타일 */
export const FACILITY_TYPE_STYLES: Record<string, { bg: string; text: string }> = {
    bridge: { bg: 'bg-blue-50', text: 'text-blue-600' },
    tunnel: { bg: 'bg-purple-50', text: 'text-purple-600' },
    retaining_wall: { bg: 'bg-amber-50', text: 'text-amber-600' },
    cut_slope: { bg: 'bg-green-50', text: 'text-green-600' },
    building: { bg: 'bg-orange-50', text: 'text-orange-600' },
};
